/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  export(conversationID) {
    return axios.get(`${this.url}/${conversationID}/export`, {
      responseType: 'blob',
    });
  }

  bulkExport(conversationIds) {
    // Ensure conversationIds is an array
    const ids = Array.isArray(conversationIds) ? conversationIds : [conversationIds];
    
    return axios.get(`${this.url}/bulk_export`, {
      params: { conversation_ids: ids },
      responseType: 'blob',
    });
  }

  getAllConversations(params = {}) {
    return axios.get(this.url, {
      params: {
        page: 1,
        status: 'all',
        assignee_type: 'all',
        ...params
      }
    });
  }
}

export default new ConversationApi();
